import { Box, CircularProgress, Typography, Skeleton } from '@mui/material';

interface AdminLoadingStateProps {
  type?: 'spinner' | 'skeleton';
  message?: string;
  rows?: number;
}

/**
 * AdminLoadingState - Loading state component for admin pages
 *
 * Features:
 * - Spinner or skeleton loading
 * - Optional loading message
 * - Configurable skeleton rows
 */
export default function AdminLoadingState({
  type = 'spinner',
  message = 'Loading...',
  rows = 5,
}: AdminLoadingStateProps) {
  if (type === 'skeleton') {
    return (
      <Box sx={{ p: 2 }}>
        {Array.from({ length: rows }).map((_, index) => (
          <Skeleton
            key={index}
            variant="rectangular"
            height={60}
            sx={{ mb: 1, borderRadius: 1 }}
          />
        ))}
      </Box>
    );
  }

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        py: 8,
      }}
    >
      <CircularProgress sx={{ mb: 2 }} />
      <Typography variant="body2" color="text.secondary">
        {message}
      </Typography>
    </Box>
  );
}
